// Shared types and formatters for API Costs date selections
export type MonthSel = { year: number; month: number };
export type DaySel = { year: number; month: number; day: number };

export const pad2 = (n: number) => String(n).padStart(2, "0");
export const formatMonth = (y: number, m: number) => `${y}-${pad2(m)}`;
export const formatDay = (y: number, m: number, d: number) => `${y}-${pad2(m)}-${pad2(d)}`;

export const externalFilter = (selected: string | null) => ({
    externalId: selected && selected !== "none" ? parseInt(selected) : null,
    noExternal: selected === "none" ? true : null,
});
